import FilteredAnnotations from "./patterns/AnnotationsFiltered";
import GroupAnnotations from "./patterns/AnnotationsGroup";
import Issues from "./patterns/Issues";
import Journals from "./patterns/Journals";
import MyAnnotations from "./patterns/AnnotationsMy";
import MyStarred from "./patterns/MyStarred";
import ProjectCollectionsBackend from "./patterns/ProjectCollectionsBackend";
import ProjectCollectionsFrontend from "./patterns/ProjectCollectionsFrontend";
import Projects from "./patterns/Projects";
import ReadingGroups from "./patterns/ReadingGroups";
import ResourceCollections from "./patterns/ResourceCollections";

export default {
  FilteredAnnotations,
  GroupAnnotations,
  Issues,
  Journals,
  MyAnnotations,
  MyStarred,
  ProjectCollectionsBackend,
  ProjectCollectionsFrontend,
  Projects,
  ReadingGroups,
  ResourceCollections
};
